import { selectedViewSelector } from "./selectedViewSelector";
import { filtersFromViewCombiner } from "./filtersFromViewCombiner";
import { RootState } from "../../../../store";

export const viewRegionsFilterSelector = (state: RootState) => {
  const view = selectedViewSelector(state);

  return filtersFromViewCombiner("region", view?.filters);
};
